import { render, staticRenderFns } from "./ProductFamilyForm.vue?vue&type=template&id=5d7d603c&scoped=true&"
import script from "./ProductFamilyForm.vue?vue&type=script&lang=js&"
export * from "./ProductFamilyForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductFamilyForm.vue?vue&type=style&index=0&id=5d7d603c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7d603c",
  null
  
)

export default component.exports